import React, { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const PhoneVerificationFailedLazy = lazyLoader(
  () =>
    import(
      './VerificationFailed' /* webpackChunkName: "phone-verification-failed" */
    ),
);

const PhoneVerificationFailed = () => {
  return (
    <Suspense fallback={null}>
      <PhoneVerificationFailedLazy />
    </Suspense>
  );
};

export default PhoneVerificationFailed;
